// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1f0rv","footer":"styles_footer__2u0Gv"};